import * as React from 'react'
import { MediaManager } from 'traveldesk-ui'
const MediaManagerPage = () => {
    return <MediaManager
        selected={[]}
        nonSelectable
    />
}
export default MediaManagerPage